import { render, staticRenderFns } from "./TypesTableMobile.vue?vue&type=template&id=e1e6cdce&scoped=true&lang=pug&"
import script from "./TypesTableMobile.vue?vue&type=script&lang=js&"
export * from "./TypesTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./TypesTableMobile.vue?vue&type=style&index=0&id=e1e6cdce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e6cdce",
  null
  
)

export default component.exports